import { Mileage } from "@finway-group/shared/lib/models"
import { isNumeric } from "@finway-group/shared/lib/utils/common"
import { MAX_MILEAGE_DISTANCE_KM, checkIsMileageDistanceValid } from "@finway-group/shared/lib/utils/validators"
import { Rule } from "antd/lib/form"
import { generalRules } from "~Components/forms/rules/common/general.rules"
import { stringRules } from "~Components/forms/rules/common/string.rules"
import { i18n } from "~Shared/locales/i18n"
import { NotificationService } from "~Shared/services"
import { NotificationTypeEnum } from "~Shared/services/notification.service"
import { isEmptyString } from "~Shared/utils/helper.utils"

export const createMileageRules = (mileage: Mileage, isDistanceOverExpectedDistanceThreshold?: boolean, hasUserNoticedPrompt?: boolean) => ({
    additionalStopReason: [
        {
            required: true,
            validator: (_rule, value: string) => {
                if ((!value || isEmptyString(value)) && isDistanceOverExpectedDistanceThreshold) {
                    if (!hasUserNoticedPrompt) {
                        NotificationService.send(NotificationTypeEnum.WARNING, i18n.t("error:error"), i18n.t("validation:mileage.must_provide_reason"))
                    }
                    return Promise.reject(new Error(i18n.t("validation:mileage.must_provide_reason")))
                }
                return Promise.resolve()
            },
        },
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
    actualDistance: [
        {
            validator: (_rule, value: string) => {
                if (!isNumeric(value)) {
                    return Promise.reject(i18n.t("validation:numeric"))
                }

                if (!Number.isInteger(Number(value))) {
                    return Promise.reject(i18n.t("validation:integer"))
                }

                if (!checkIsMileageDistanceValid(parseFloat(value))) {
                    return Promise.reject(new Error(i18n.t("validation:between.number.exclusive_min_inclusive_max", { max: MAX_MILEAGE_DISTANCE_KM, min: 0 })))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    stops: [
        {
            required: true,
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(new Error(i18n.t("validation:required_mileage_stops")))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    mileageDate: [
        {
            required: true,
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(new Error(i18n.t("validation:required")))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    tripReason: [
        // keep line breaks
        generalRules.required,
        stringRules.noExcessWhitespace,
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
})
